import { render, staticRenderFns } from "./AddRedirectDialog.vue?vue&type=template&id=3c335ab8&scoped=true&"
import script from "./AddRedirectDialog.vue?vue&type=script&lang=js&"
export * from "./AddRedirectDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddRedirectDialog.vue?vue&type=style&index=0&id=3c335ab8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c335ab8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c335ab8')) {
      api.createRecord('3c335ab8', component.options)
    } else {
      api.reload('3c335ab8', component.options)
    }
    module.hot.accept("./AddRedirectDialog.vue?vue&type=template&id=3c335ab8&scoped=true&", function () {
      api.rerender('3c335ab8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/redirect-domains/AddRedirectDialog.vue"
export default component.exports